import { isOfType } from '../../../../ts-utils';
const replyStateTags = [
    'REPLY_TYPING',
    'REPLY_CREATE_PENDING',
    'REPLY_CREATE_ERROR',
    'REPLY_CREATE_ERROR_EDITING',
    'REPLY_READY',
    'REPLY_EDITING',
    'REPLY_UPDATE_PENDING',
    'REPLY_UPDATE_ERROR',
    'REPLY_DELETE_PENDING',
    'REPLY_DELETED',
    'REPLY_LIVE_PENDING',
];
export const isReplyStateIN = isOfType(replyStateTags);
export const isReplyStateOUT = isOfType(replyStateTags);
//# sourceMappingURL=reply-types.js.map